export default {
  siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
};
